import USER_MANAGEMENT from './es/fe_user_management.json'
import INTEGRATIONS from './es/fe_integrations.json'
import TRAININGS from './es/fe_trainings.json'
import SECURITY_OBJECTIVES from './es/fe_security_objectives.json'
import COMPLIANCE from './es/fe_compliance.json'
import TRAINING_PROGRAM from './es/fe_training_programs.json'
import ACCOUNT from './es/account.json'
import ACCOUNT_SETTINGS from './es/account_settings.json'
import APP from './es/app.json'
import EXPERTA from './es/experta.json'
import COMMON from './es/fe_common.json'
import COMPANY_SETTINGS from './es/company_settings.json'
import CONSULTANT from './es/consultant.json'
import DISCUSSION from './es/discussion.json'
import DOCUMENT_MANAGEMENT_SYSTEM from './es/document_management_system.json'
import DOCUMENT_WIZARD from './es/document_wizard.json'
import ERRORS from './es/fe_errors.json'
import FORM from './es/form.json'
import ISO_27001 from './es/iso_27001.json'
import LANGUAGES from './es/languages.json'
import MY_WORK from './es/my_work.json'
import ONBOARDING from './es/onboarding.json'
import ORGANIZATION from './es/organization.json'
import PREONBOARDING from './es/fe_preonboarding.json'
import PRICING from './es/pricing.json'
import REGISTER_WIZARD from './es/register_wizard.json'
import CORRECTIVE_ACTIONS from './es/corrective_actions.json'
import INCIDENTS from './es/fe_incidents.json'
import INTERNAL_AUDITS from './es/internal_audits.json'
import NONCONFORMITIES from './es/nonconformities.json'
import REQUIREMENTS from './es/fe_requirements.json'
import RISKS from './es/fe_risks.json'
import SOA from './es/soa.json'
import TRAINING_MODULE from './es/training_module.json'
import REGISTERS_DATA from './es/registers.json'
import REGISTERS_AND_MODULES from './es/registers_and_modules.json'
import REPORTING from './es/reporting.json'
import RESOURCE from './es/resource.json'
import SETTINGS from './es/settings.json'
import SLACK from './es/slack.json'
import STEP_INPUTS from './es/step_inputs.json'
import TASKS from './es/fe_tasks.json'
import VALIDATION from './es/fe_validation.json'
import REGULATION_DATA from './es/regulation.json'
import CUSTOM_STEP from './es/custom_step.json'
import SIMPLE_STEP from './es/simple_step.json'
import STEP_0 from './es/step0.json'
import STEP_1 from './es/step1.json'
import STEP_2 from './es/step2.json'
import STEP_3 from './es/step3.json'
import STEP_4 from './es/step4.json'
import STEP_5 from './es/step5.json'
import STEP_6 from './es/step6.json'
import STEP_7 from './es/step7.json'
import STEP_8 from './es/step8.json'
import STEP_9 from './es/step9.json'
import STEP_10 from './es/step10.json'
import STEP_11 from './es/step11.json'
import STEP_12 from './es/step12.json'
import STEP_13 from './es/step13.json'
import STEP_14 from './es/step14.json'
import STEP_15 from './es/step15.json'
import STEP_16 from './es/step16.json'
import STEP_17 from './es/step17.json'
import STEP_18 from './es/step18.json'
import STEP_19 from './es/step19.json'
import STEP_20 from './es/step20.json'
import STEP_21 from './es/step21.json'
import STEP_22 from './es/step22.json'
import STEP_23 from './es/step23.json'
import STEP_24 from './es/step24.json'
import STEP_25 from './es/step25.json'
import STEP_26 from './es/step26.json'
import STEP_27 from './es/step27.json'
import STEP_28 from './es/step28.json'
import STEP_29 from './es/step29.json'
import STEP_30 from './es/step30.json'
import STEP_31 from './es/step31.json'
import STEP_32 from './es/step32.json'
import STEP_33 from './es/step33.json'
import STEP_34 from './es/step34.json'
import STEP_37 from './es/step37.json'
import STEP_39 from './es/step39.json'
import STEP_40 from './es/step40.json'
import STEP_42 from './es/step42.json'
import STEP_66 from './es/step66.json'
import STEP_77 from './es/step77.json'
import STEP_88 from './es/step88.json'
import STEP_99 from './es/step99.json'

const REGULATION = {
    ...REGULATION_DATA,
    ...CUSTOM_STEP,
    ...SIMPLE_STEP,
    ...STEP_0,
    ...STEP_1,
    ...STEP_2,
    ...STEP_3,
    ...STEP_4,
    ...STEP_5,
    ...STEP_6,
    ...STEP_7,
    ...STEP_8,
    ...STEP_9,
    ...STEP_10,
    ...STEP_11,
    ...STEP_12,
    ...STEP_13,
    ...STEP_14,
    ...STEP_15,
    ...STEP_16,
    ...STEP_17,
    ...STEP_18,
    ...STEP_19,
    ...STEP_20,
    ...STEP_21,
    ...STEP_22,
    ...STEP_23,
    ...STEP_24,
    ...STEP_25,
    ...STEP_26,
    ...STEP_27,
    ...STEP_28,
    ...STEP_29,
    ...STEP_30,
    ...STEP_31,
    ...STEP_32,
    ...STEP_33,
    ...STEP_34,
    ...STEP_37,
    ...STEP_39,
    ...STEP_40,
    ...STEP_42,
    ...STEP_66,
    ...STEP_77,
    ...STEP_88,
    ...STEP_99
}

const REGISTERS = {
    CORRECTIVE_ACTIONS,
    INCIDENTS,
    INTERNAL_AUDITS,
    NONCONFORMITIES,
    RISKS,
    SOA,
    TRAINING_MODULE,
    ...REGISTERS_DATA
}

export const ES = {
    TRAININGS,
    SECURITY_OBJECTIVES,
    REQUIREMENTS,
    COMPLIANCE,
    ACCOUNT,
    ACCOUNT_SETTINGS,
    APP,
    EXPERTA,
    COMMON,
    COMPANY_SETTINGS,
    CONSULTANT,
    DISCUSSION,
    DOCUMENT_MANAGEMENT_SYSTEM,
    DOCUMENT_WIZARD,
    ERRORS,
    FORM,
    ISO_27001,
    LANGUAGES,
    MY_WORK,
    ONBOARDING,
    ORGANIZATION,
    PREONBOARDING,
    PRICING,
    REGISTER_WIZARD,
    REGISTERS,
    REGISTERS_AND_MODULES,
    REGULATION,
    REPORTING,
    RESOURCE,
    SETTINGS,
    SLACK,
    STEP_INPUTS,
    TASKS,
    USER_MANAGEMENT,
    INTEGRATIONS,
    VALIDATION,
    TRAINING_PROGRAM
}
